import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VChip,{class:[
    'app-chip',
    `circle-color-${_vm.circleColor}`,
    `bg-${_vm.background}`,
    _vm.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
  ],attrs:{"text-color":_vm.color}},[_c('div',{staticClass:"circle"},[_c(VIcon,{attrs:{"color":_vm.background}},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }